import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../axiosConfig';

const updatePriority = async ({ item, markPriority, userEmail, token }) => {
  const updateUrl = `/updatePriority/${encodeURIComponent(item.orderDetailId)}?isPriority=${encodeURIComponent(!item?.isPriority)}&Author=${encodeURIComponent(userEmail)}`;
  const headers = {
    Authorization: token,
    'Content-Type': 'application/json',
  };

  await axios.put(updateUrl, null, { headers });
};

const useUpdatePriority = (onPriorityUpdate, setToast) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ item, markPriority, userEmail, token }) => {
      await updatePriority({ item, markPriority, userEmail, token });
    },
    onSuccess: (_, { item, markPriority }) => {     
      onPriorityUpdate(!markPriority);
    },
    onError: (error) => {
      let errorMessage;
      if (error.response) {
        const status = error.response.status;
        const errorMessages = {
          401: 'Expired Token',
        };
        errorMessage = errorMessages[status] || 'An error occurred';
      } else {
        errorMessage = error.message || 'An unexpected error occurred';
      }
      setToast({ showToast: true, message: errorMessage, type: 'error' });
    },
  });
};

export default useUpdatePriority;
